export default __webpack_public_path__ + "static/first-c8381c38f0d65a4081662a98b47d9bc7.webp";